"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VehicleTracker;
exports.Styled = void 0;

var _coreUtils = _interopRequireDefault(require("@opentripplanner/core-utils"));

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../utils");

var S = _interopRequireWildcard(require("./styled"));

exports.Styled = S;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * presentational component for tracking button on marker popup
 */
function VehicleTracker({
  vehicle,
  isTracked,
  setTracked
}) {
  const text = isTracked ? /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    defaultMessage: _utils.defaultMessages["otpUi.TransitVehicleOverlay.trackStop"],
    description: "Prompt to stop tracking a vehicle.",
    id: "otpUi.TransitVehicleOverlay.trackStop"
  }) : /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    defaultMessage: _utils.defaultMessages["otpUi.TransitVehicleOverlay.trackStart"],
    description: "Prompt to start tracking a vehicle.",
    id: "otpUi.TransitVehicleOverlay.trackStart"
  });
  const cls = isTracked ? "active" : "";

  const handleClick = () => {
    setTracked(vehicle, isTracked);
  };

  return /*#__PURE__*/_react.default.createElement(S.PopupStyle.Button, {
    onClick: handleClick,
    className: cls
  }, text);
}

VehicleTracker.propTypes = {
  /** vehicle record - @see: core-utils/types/transitVehicleType */
  vehicle: _coreUtils.default.types.transitVehicleType,

  /** tracking state for this vehicle (marker) .. determines button content */
  isTracked: _propTypes.default.bool,

  /** callback for when the button is triggered ... cb(vehicle, isTracked); */
  setTracked: _propTypes.default.func.isRequired
};
VehicleTracker.defaultProps = {
  vehicle: null,
  isTracked: false
}; // Rename styled components for export
//# sourceMappingURL=vehicle-tracker.js.map